import React from 'react';
import {View, Image} from 'react-native';
import styled from 'styled-components/native';
import FailedIcon from '../assets/images/report-failed-icon.png';
import Text from './Text';

const Container = styled(View)`
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 30px;
  min-height: 300px;
`;

const Icon = styled(Image)`
  width: 60px;
  height: 60px;
`;

const Title = styled(Text)`
  font-size: 18px;
  text-align: center;
`;

const Content = styled(Text)`
  text-align: center;
  margin: 10px 0;
`;

const Thanks = styled(Text)`
  font-weight: bold;
`;

export default function ReportFailed() {
  return (
    <Container>
      <Icon source={FailedIcon} />
      <Title>Report Failed</Title>
      <Content>
        Something went wrong and we could not publish the report. Please try
        again later.
      </Content>
      <Thanks>Thank you!</Thanks>
    </Container>
  );
}
